__turbopack_context__.v({
  "logo": "pageHeader-module-scss-module__24uheW__logo",
  "pageHeader": "pageHeader-module-scss-module__24uheW__pageHeader",
  "title": "pageHeader-module-scss-module__24uheW__title",
  "titleIcon": "pageHeader-module-scss-module__24uheW__titleIcon",
  "trademark": "pageHeader-module-scss-module__24uheW__trademark",
  "wrapper": "pageHeader-module-scss-module__24uheW__wrapper",
});
